// Blocks the context menu and drag on photos. This is a threshold, not
// protection: the file is still in the page source. The disclaimer and the
// watermark do the actual work.
export default function initImageProtection() {
    const isPhoto = (target) => target instanceof HTMLImageElement && ! target.closest('[data-allow-save]');

    document.addEventListener('contextmenu', (event) => {
        if (isPhoto(event.target)) {
            event.preventDefault();
        }
    });

    document.addEventListener('dragstart', (event) => {
        if (isPhoto(event.target)) {
            event.preventDefault();
        }
    });
}
